module.exports = __webpack_public_path__ + "hyperion-v2-static/img/seerist_logo_blue_text.cebc680c.png";